module.exports = __webpack_public_path__ + "pstatic/img/report1.bab30c98.png";